import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldUser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShieldUser"><Path fillRule="evenodd" clipRule="evenodd" d="M12.4004 1.58398L21 5.3457V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.3457L11.5996 1.58398L12 1.4082L12.4004 1.58398ZM12 15C9.75889 15 7.76542 15.9041 6.48438 17.3086C7.76561 18.9464 9.75935 20 12 20C14.2402 20 16.2324 18.9459 17.5137 17.3086C16.2327 15.9045 14.2406 15 12 15ZM12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldUser;
